<template>
	<a-modal title="操作" style="top: 20px;" width="50%" v-model="visible" :confirmLoading="confirmLoading" @ok="handleSubmit">
		<a-spin :spinning="spinning">
			<a-form :form="form">
				<a-form-item style="display:none">
					<a-input v-decorator="['userId']" />
				</a-form-item>
				<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="登录名">
					<a-input placeholder="用户名" :disabled="boo" v-decorator="['loginName', {rules: [{ required: true, message: '请输入用户名' }]}]" />
				</a-form-item>

				<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户名">
					<a-input v-decorator="[
              'userName',
              {
                rules: [{ required: true, message: '请输入昵称' }]
              }
            ]"
					 placeholder="起一个名字" />
				</a-form-item>
				<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电话">
					<a-input placeholder="电话" v-decorator="['phonenumber', {rules: [{ required: true, message: '请输入电话' },{pattern: new RegExp(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/), message: '请输入电话' }]}]" />
				</a-form-item>
				<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="邮箱">
					<a-input placeholder="邮箱" v-decorator="['email', {rules: [{ required: true, message: '请输入邮箱' },{pattern: new RegExp(/^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/), message: '请输入邮箱' }]}]" />
				</a-form-item>
				<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
					<a-select v-decorator="['status', {initialValue:'0',rules: [{ required: true, message: '请选择状态' }]}]">
						<a-select-option :value="'0'">正常</a-select-option>
						<a-select-option :value="'1'">停用</a-select-option>
					</a-select>
				</a-form-item>

				<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门">
					<a-tree-select v-decorator="['deptId', {rules: [{ required: true, message: '请选择部门' }]}]" :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
					 :treeData="deptTree" @change="onChange" placeholder="部门" treeDefaultExpandAll>
					</a-tree-select>
				</a-form-item>
				<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="员工类型">
					<a-select v-decorator="['isLeader', {initialValue:0,rules: [{ required: true, message: '请选择' }]}]" :disabled="!roleType">
						<a-select-option :value="0">普通员工</a-select-option>
						<a-select-option :value="1">非普通员工</a-select-option>
					</a-select>
				</a-form-item>
				<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="职能部门">
					<a-select v-decorator="['isGroup', {initialValue:0,rules: [{ required: true, message: '请选择' }]}]">
						<a-select-option :value="0">否</a-select-option>
						<a-select-option :value="1">是</a-select-option>
					</a-select>
				</a-form-item>
				<a-row>
					<a-col :span="12">
						<a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="自定义审批权限" v-if="customPerEnable">
							<a-tree checkable :autoExpandParent="autoExpandParent" v-if="deptTree2.length>0" v-model="checkedKeys" :treeData="deptTree2" 
							 @check="onCheck">
							</a-tree>
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="自定义数据权限" v-if="customPerEnable">
							<a-tree checkable :autoExpandParent="autoExpandParent" v-if="deptTree2.length>0" v-model="checkedKeys2" checkStrictly
							 :treeData="deptTree2" @check="onCheck2">
							</a-tree>
						</a-form-item>
					</a-col>
				</a-row>

				<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="描述">
					<a-textarea :rows="5" placeholder="..." v-decorator="['remark', {rules: [{ required: true, message: '请输入描述' }]}]" />
				</a-form-item>

				<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="拥有角色" hasFeedback>
					<a-select :disabled="!editRoleEnable" style="width: 100%" mode="multiple" v-decorator="['roleIds', {rules: [{ required: true, message: '请选择角色' }]}]"
					 :allowClear="true" show-search :filter-option="filterOption">
						<a-select-option v-for="(action) in roleAll" :key="action.roleId">{{ action.roleName }}</a-select-option>
					</a-select>
				</a-form-item>

			</a-form>
		</a-spin>
	</a-modal>
</template>
<script>
	import {
		getRoleAll,
		saveUser,
		getUser,
		getDeptList,
		getRoleDeptIds
	} from '@/api/system'
	import pick from 'lodash.pick'
	import {
		checkPermission
	} from '@/utils/permissions'
	export default {
		name: 'UserModal',
		props: {
			deptTree: {
				type: Array,
				required: true
			}
		},
		components: {},
		data() {
			return {
				roleType: false,
				boo:false,
				description: '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
				visible: false,
				labelCol: {
					xs: {
						span: 24
					},
					sm: {
						span: 5
					}
				},
				wrapperCol: {
					xs: {
						span: 24
					},
					sm: {
						span: 16
					}
				},
				labelCol2: {
					span:12
				},
				wrapperCol2: {
					span:5
				},
				confirmLoading: false,
				roleAll: [],
				mdl: {},
				deptCheck: true,
				spinning: false,
				deptTree2: [],
				dataScope: false,
				pidSet: [],
				pidSet2: [],
				treeCheck: false,
				treeCheck2: false,
				autoExpandParent: true,
				checkedKeys: [],
				checkedKeys2: [],
				halfCheckedKeys: [],
				halfCheckedKeys2: [],
				form: this.$form.createForm(this),
				customPerEnable: checkPermission('system:user:customPer'), //自定义权限
				editRoleEnable: checkPermission('system:user:editRole'), //编辑角色
			}
		},
		beforeCreate() {},
		created() {
			this.loadRoleAll()
			getDeptList().then(res => {
				const data = res.rows
				if (data.length > 0) {
					const pids = data.map(m => m.parentId)
					this.buildtree(data, this.deptTree2, Math.min(...pids))
					const pidSet = new Set(pids.map(m => m + ''))
					this.pidSet = pidSet
					this.pidSet2 = pidSet
				}
				

			})
		},
		methods: {
			 filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			onCheck(checkedKeys, info) {
				console.log('onCheck', info)
				if (!this.treeCheck) this.treeCheck = true
				this.checkedKeys = checkedKeys
				this.halfCheckedKeys = info.halfCheckedKeys
			},
			onCheck2(checkedKeys, info) {
				// this.checkedKeys2 = []
				console.log(checkedKeys, '=================================')
				console.log('onCheck', info)
				if (!this.treeCheck2) this.treeCheck2 = true
				this.checkedKeys2 = checkedKeys.checked
				this.halfCheckedKeys2 = info.halfCheckedKeys
			},
			buildtree(list, arr, parentId) {
				list.forEach(item => {
					if (item.parentId === parentId) {
						var child = {
							key: item.deptId + '',
							value: item.deptId + '',
							title: item.deptName,
							children: []
						}
						this.buildtree(list, child.children, item.deptId)
						if (child.children.length === 0) {
							delete child.children
						}
						arr.push(child)
					}
				})
				// console.log(arr, 'arr=====================')
			},
			add() {
				this.roleType = false
				this.$store.getters.userInfo.roles.forEach(item=>{
					if(item.roleId==1) {
						this.roleType = true
					}
				})
				this.boo=false
				this.form.resetFields()
				this.mdl = Object.assign({}, {
					userId: 0,
					deptId: ''
				})
				this.checkedKeys = []
				this.checkedKeys2 = []
				this.visible = true
				this.$nextTick(() => {
					this.form.setFieldsValue(pick(this.mdl, 'userId','phonenumber', 'email', 'loginName', 'userName', 'status', 'roleIds',
						'remark',
						'deptId',
						'isLeader',
						'isGroup',
						))
					this.form.setFieldsValue({
						roleIds: [16]
					})
				})
			},
			edit(record) {
				this.boo=true
				this.roleType = false
				this.$store.getters.userInfo.roles.forEach(item=>{
					if(item.roleId==1) {
						this.roleType = true
					}
				})
				if (record.userId > 0) {
					this.spinning = true
					getUser(record.userId).then(res => {
						if (res.otherDeptIds) {
							this.checkedKeys = res.otherDeptIds.filter(id => !this.pidSet.has(id))
							this.checkedKeys = this.checkedKeys.concat(res.otherDeptIds.filter(id => this.pidSet.has(id)))
						} else {
							this.checkedKeys = []
						}
						if (res.userPermissions) {
							this.checkedKeys2 = res.userPermissions.filter(id => !this.pidSet2.has(id))
							this.checkedKeys2 = this.checkedKeys2.concat(res.userPermissions.filter(id => this.pidSet2.has(id)))
							console.log(this.checkedKeys2)
						} else {
							this.checkedKeys2 = []
						}
						this.mdl = Object.assign({}, res)
						this.visible = true
						this.$nextTick(() => {
							this.form.setFieldsValue(pick(this.mdl, 'userId','phonenumber', 'email', 'loginName', 'userName', 'status', 'roleIds',
								'remark',
								'deptId',
								'isLeader',
						        'isGroup',))
							this.spinning = false
							// this.form.setFieldsValue({ ...record })
						})
					})
				}
			},
			onChange(value, label, extra) {
				if (extra.triggerNode.$children.length > 0) {
					this.$message.error('不能选择父节点' + `${label}`)
					this.deptCheck = false
				} else {
					this.deptCheck = true
				}
			},
			loadRoleAll() {
				getRoleAll().then(res => {
					this.roleAll = res.rows
				})
			},
			handleSubmit(e) {
				e.preventDefault()
				if (!this.deptCheck) {
					this.$message.error('不能选择父节点')
					return
				}
				// const _this = this
				// const checkedAll = this.treeCheck ? _this.checkedKeys.concat(_this.halfCheckedKeys) : _this.checkedKeys.concat(
				// 	Array.from(_this.pidSet))
				// const checkedAll2 = this.treeCheck2 ? _this.checkedKeys2.concat(_this.halfCheckedKeys2) : _this.checkedKeys2.concat(
				// 	Array.from(_this.pidSet2))
				this.form.validateFields((err, values) => {
					if (!err) {
						console.log('Received values of form: ', values)
						this.confirmLoading = true
							console.log(this.checkedKeys, 'this.checkedKeys========================')
							console.log(this.checkedKeys2, 'this.checkedKeys2==========================')
						values['otherDeptIds'] = this.checkedKeys
						values['userPermissions'] = this.checkedKeys2
						saveUser(Object.assign(values)).then(res => {
							if (res.code === 200) {
								this.$message.success('保存成功')
								this.$emit('ok')
								this.visible = false
							} else {
								this.$message.error(res.msg)
							}
						}).catch(() => {
							this.$message.error('系统错误，请稍后再试')
						}).finally(() => {
							this.confirmLoading = false
						})
					}
				})
			}
		},
		watch: {
			/*
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			  */
		}
	}
</script>
